// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const defaultDialogOnCloseEventHandler = (_event: any, reason: any): boolean => {
    switch (reason) {
        case 'backdropClick':
        case 'escapeKeyDown':
            return false;
    }
    return true;
};
